// How a player likes the game shown, kept in this browser (localStorage): set on the profile page, read by the game.
// Other tabs open in the same browser follow a change at once.
import { useEffect, useState } from 'react';

// Static buttons: the action bar under the player's board (a button for each kind of action, its target picked where
// it is) in place of the action panel's buttons for those actions. Off unless chosen.
const StaticButtonsKey = 'tta-static-buttons';

const read = (key) => {
    try { return window.localStorage.getItem(key) === 'on'; } catch { return false; }
};

export const useStaticButtons = () => {
    const [on, setOn] = useState(() => read(StaticButtonsKey));
    useEffect(() => {
        const changed = (event) => event.key === StaticButtonsKey && setOn(read(StaticButtonsKey));
        window.addEventListener('storage', changed);
        return () => window.removeEventListener('storage', changed);
    }, []);
    const set = (value) => {
        try { window.localStorage.setItem(StaticButtonsKey, value ? 'on' : 'off'); } catch { /* (then only for this page) */ }
        setOn(value);
    };
    return [on, set];
};
